/* eslint-disable */
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { fetchProducts } from "./products";

export const addMultipleProducts = (productsArray) => {
  return async (dispatch, getState) => {
    try {
      // Get user from userReducer
      const user = getState().userReducer.user;

      if (!user) {
        console.error("User not found");
        return false;
      }

      // Create reference to products collection
      const productsRef = collection(db, "products");

      // Add all products to Firestore
      const addedProducts = [];
      for (const product of productsArray) {
        const docRef = await addDoc(productsRef, {
          ...product,
          user: user,
          timeStamp: serverTimestamp(),
        });
        addedProducts.push({
          id: docRef.id,
          ...product,
        });
      }

      // Get current products from Redux state
      const currentProducts = getState().ProductsReducer || [];

      // Combine current products with newly added ones
      const updatedProducts = [...addedProducts, ...currentProducts];

      // Update Redux state with all products
      dispatch(fetchProducts(updatedProducts));

      return true;
    } catch (error) {
      console.error("Error adding multiple products:", error);
      return false;
    }
  };
};
